﻿import React from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ajaxQueue } from "./common/api/ajaxQueue";
import { useNavigate } from "react-router";
import { shareUnlessManualWrite } from "@common/hooks/manualQueryWrites.ts";

export interface IQueryClientProviderPrivacyProps {
    children: any;
}

const queryClient = new QueryClient();

window.addEventListener("beforeunload", function (e) {
    if (queryClient.isMutating() || ajaxQueue().isItemsOnQueue()) {
        // Cancel the event
        e.preventDefault(); // If you prevent default behavior in Mozilla Firefox prompt will always be shown
        // Chrome requires returnValue to be set
        e.returnValue = "";
    }
});

function QueryClientProviderPrivacy(props: IQueryClientProviderPrivacyProps) {
    const navigate = useNavigate();

    queryClient.setDefaultOptions({
        mutations: {
            onError: async (error: Error) => {
                queryClient.getMutationCache().clear();
                ajaxQueue().clear();
                navigate("/privacy/error");
            },
        },
        queries: {
            throwOnError: true,
            structuralSharing: shareUnlessManualWrite,
        },
    });

    return <QueryClientProvider client={queryClient}>{props.children}</QueryClientProvider>;
}

export default QueryClientProviderPrivacy;
